module.exports = "<label :for=\"id\" class=\"weui_cell weui_check_label\">\n  <cell-body>{{{label}}}</cell-body>\n  <cell-footer>\n    <input type=\"radio\" :name=\"name\" class=\"weui_check\" :id=\"id\" :value=\"value\" v-model=\"picked\">\n    <span class=\"weui_icon_checked\"></span>\n  </cell-footer>\n</label>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/radio-cell.vue
 ** module id = 76
 ** module chunks = 0
 **/